import PasswordAccess from './PasswordAccess';
// src/components/auth/LoginScreen.js
import React, { useEffect, useState } from 'react';
import { css } from '../../App';
import { PRODUCT_BRAND } from '../../appBranding';

function LoginScreen({ urlError, adminMode = false }) {
  const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const appName = PRODUCT_BRAND.name;
  const logo = PRODUCT_BRAND.symbol;

  return (
    <><style>{css}</style>
      <div className="login-screen"><div className="login-box">
        <div className="login-brand-mark" style={{ minHeight: 64, marginBottom: 4, display: 'grid', placeItems: 'center' }}>
          {logo
            ? <img src={logo} alt={`${appName} logo`} style={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 14, background: '#fff', padding: 5 }} />
            : <div style={{ width: 64, height: 64, borderRadius: 14, display: 'grid', placeItems: 'center', fontSize: 28, fontWeight: 800, background: '#eef2ff', color: '#4f46e5' }}>{appName[0] || 'W'}</div>}
        </div>
        <h2>{adminMode ? `${appName} Admin` : appName}</h2>
        <p>{adminMode ? 'Sign in with the Google account authorized as a superadmin' : 'Sign in with your Google account to access your dashboard'}</p>
        {urlError === "suspended" && <div className="alert alert-error" style={{ textAlign: "left" }}><strong>Account suspended.</strong><br />This business has been suspended. Contact the system admin to restore access.</div>}
        {urlError === "auth" && <div className="alert alert-error">Sign-in failed. Please try again.</div>}
        {urlError === "not-admin" && <div className="alert alert-error">This Google account is not authorized as a Wavelines ERP superadmin.</div>}
        {urlError === "server" && <div className="alert alert-error">Google sign-in succeeded, but the ERP server could not finish loading your account. Please refresh after the service recovers.</div>}
        {!adminMode && <PasswordAccess />}
        <div className="divider" />
        <button className="google-btn" onClick={() => {
          window.location.href = adminMode
            ? `${BASE}/auth/google?intent=admin&returnTo=${encodeURIComponent(window.location.origin)}`
            : `${BASE}/auth/google?returnTo=${encodeURIComponent(window.location.origin)}`;
        }}>
          <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z" /><path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2.01c-.72.48-1.63.77-2.7.77a4.82 4.82 0 0 1-4.52-3.34H1.83v2.07A8 8 0 0 0 8.98 17z" /><path fill="#FBBC05" d="M4.46 10.48A4.86 4.86 0 0 1 4.2 9c0-.51.09-1 .26-1.48V5.45H1.83a8 8 0 0 0 0 7.1l2.63-2.07z" /><path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.45L4.46 7.52A4.82 4.82 0 0 1 8.98 4.18z" /></svg>
          {adminMode ? 'Sign in as Superadmin' : 'Sign in with Google'}
        </button>

        {adminMode ? (
          <div className="alert alert-info" style={{ marginTop: 12, fontSize: 11 }}>🔐 Superadmin access is verified by the backend after Google sign-in.</div>
        ) : (
          <>
            <div className="divider" style={{ margin: "16px 0 12px" }} />
            <button
              className="btn btn-secondary"
              style={{ width: "100%" }}
              onClick={() => { window.location.href = `${BASE}/auth/google?intent=create-business&returnTo=${encodeURIComponent(window.location.origin)}`; }}
            >
              🏪 Create Business
            </button>
            <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 10 }}>
              Want your own workspace, even if this email is already staff at another business? Verify with Google, then set up your business.
            </p>
          </>
        )}
        {adminMode && (
          <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 8 }}>
            Added as a platform admin with a specific role (not superadmin)? Sign in at the <a href="/admin-portal" style={{ color: "#9ca3af", textDecoration: "underline" }}>Admin Portal</a> instead.
          </p>
        )}
      </div>
      <p style={{ textAlign: "center", fontSize: 11, color: "#9ca3af", marginTop: 16 }}><a href="/privacy-policy" style={{ color: "#9ca3af", textDecoration: "underline" }}>Privacy Policy</a></p>
      </div></>
  );
}

export default LoginScreen;
